import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { getPaymentCreationState } from "../redux/paymentSelectors";
import { getSupplierData } from "../../../Redux/Selectors/appConfigSelector";
import { getPaymentById } from "../../../Redux/Selectors/paymentSelector";
import { PAYMENT_METHOD_LABELS } from "../PaymentMethods";
import {
  getPaymentMethodsFromSupplierRequest,
  transactionPaymentCreateRequest,
} from "../redux/paymentActions";
import { Card } from "antd";
import CustomBookingId from "../../../components/CustomBookingId/CustomBookingId";
import Section from "../components/Section";
import { StyledSummaryPaymentDetail } from "../components/PaymentMethodSelection.styles";
import Paragraph from "antd/es/typography/Paragraph";

const ManualPaymentMethodScreen = ({
  transactionId,
  transactionCustomId,
  amount,
  currency,
  onReady,
  summary,
}) => {
  const { t } = useTranslation(["shop", "common"]);
  const dispatch = useDispatch();
  const {
    paymentId,
    loading: paymentCreationLoading,
    error: paymentCreationError,
    success: paymentCreationSuccess,
  } = useSelector(getPaymentCreationState, shallowEqual);
  const supplierData = useSelector(getSupplierData, shallowEqual);
  const payment = useSelector((state) => getPaymentById(state, paymentId));

  useEffect(() => {
    dispatch(
      transactionPaymentCreateRequest({
        provider: PAYMENT_METHOD_LABELS.shopCard,
        amount,
        currency,
        transactionId,
      })
    );
    dispatch(getPaymentMethodsFromSupplierRequest(supplierData._id));
  }, []);

  useEffect(() => {
    if (
      !payment ||
      paymentCreationLoading ||
      (!paymentCreationSuccess && !paymentCreationError)
    ) {
      return;
    }
    onReady();
  }, [payment, paymentCreationSuccess, paymentCreationError]);

  return (
    <Card>
      <CustomBookingId customId={transactionCustomId} />
      {summary && (
        <Section title={t("paymentSummary")}>
          <StyledSummaryPaymentDetail {...summary} />
        </Section>
      )}
      <Paragraph>Nos pondremos en contacto contigo para finalizar el proceso de reserva.</Paragraph>
      <Paragraph strong>Muchas gracias</Paragraph>
    </Card>
  );
};

export default ManualPaymentMethodScreen;
